import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY ?? '';

if (process.env.NODE_ENV === 'development' && !supabaseAnonKey.trim()) {
  console.error(
    '[Supabase] REACT_APP_SUPABASE_ANON_KEY is empty in frontend-new/.env.local.\n' +
      'Set it (and REACT_APP_SUPABASE_URL) then restart npm start — see .env.example, helm/values.yaml, or rebuild-eks.sh (gitignored).'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});
